/* VISTA Caja para /caja . 
Muestra las cajas y permite su creacion */
import React, { useEffect, useState } from "react";
import { Container,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams } from "react-router-dom";
import { api } from "../../services/api";
import { toast } from 'react-toastify';

import CajaTab from "../../components/VentaPresencial/CajaYStock/CajaTab";

const Caja = () => {
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [vendedores, setVendedores] = useState([]);
  const [allTarifas, setAllTarifas] = useState([]);

  const [allCajas, setAllCajas] = useState([]);
  const [loadingCajas, setLoadingCajas] = useState(true);

  const fetchAllCajas = async () => {
    setLoadingCajas(true);
    const res = await api.caja.getAllCajas(id);
    if (res.status === 'success') {
      setAllCajas(res.data);
    }
    setLoadingCajas(false);
  };

  useEffect(() => {
    const fetchVendedores = async () => {
      const res = await api.vendedores.getVendedores(id, '');
      if (res.status === 'success') {
        const vendedoresUnicos = [];
        const idsUsados = new Set();
        const emailsUsados = new Set();

        res.data?.forEach(v => {
          if (!idsUsados.has(v.id) && !emailsUsados.has(v.email)) {
            vendedoresUnicos.push({
              id: v.id,
              nombre: v.nombre || '',
              apellido: v.apellido || '',
              email: v.email || '',
              caja: v.caja || ''
            });
            idsUsados.add(v.id);
            emailsUsados.add(v.email);
          }
        });
        setVendedores(vendedoresUnicos);
      }
    };

    const fetchAllTarifas = async () => {
      const res = await api.tarifas.getTarifaByEventoWithoutPagination(id);
      if (res.status === 'success') setAllTarifas(res.data?.tarifas ?? []);
    };

    fetchVendedores();
    fetchAllTarifas();
    fetchAllCajas();
  }, [id]);

  const showSuccess = (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
    });
  };

  const showError = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 4000,
    });
  };

  return (
    <Container maxWidth="md" sx={{ mt: 2 }}>
      <CajaTab
          eventoId={id}
          vendedores={vendedores}
          allTarifas={allTarifas}
          allCajas={allCajas}
          loadingCajas={loadingCajas}
          refetchCajas={fetchAllCajas}
          isMobile={isMobile}
          onSuccess={showSuccess}
          onError={showError}
        />
    </Container>
  );
};

export default Caja;